<template>
  <div>
    <h5>Filtros</h5>
    <div class="input-group">
      <input
        type="text"
        class="form-control"
        placeholder="Digite o nome do vendedor"
        aria-label="Pesquisar"
        aria-describedby="pesquisar"
        v-model="pesquisa"
        @keyup.enter="pesquisar()"
      />
      <div class="input-group-append">
        <button
          class="btn bg-orange"
          aria-label="Fazer uma pesquisa dentro do site"
          type="button"
          id="pesquisar"
          @click="pesquisar()"
        >
          <i class="fas fa-search text-white"></i>
        </button>
      </div>
    </div>
    <div class="mt-3 fs-20">
      <b-badge variant="success">Aprovado</b-badge>
      <b-badge variant="primary" class="ml-3 mr-3">Aguardando aprovação</b-badge>
      <b-badge variant="danger">Cancelado</b-badge>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FilterBar',
  data: () => ({
    pesquisa: null,
  }),
  methods: {
    pesquisar() {
      this.$router.push({ name: 'pesquisa', params: { pesq: this.pesquisa } });
    },
  },
};
</script>
